import { Injectable } from '@angular/core';
import { selectAllText } from '@core/helpers';
import { InputComponent } from './input.component';
import { InputSwitchChangeEvent } from 'primeng/inputswitch';
import { Observable } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { InputNumberInputEvent } from 'primeng/inputnumber';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Injectable({
  providedIn: 'root',
})
export class InputPresenter<T> {
  view!: InputComponent<T>;

  setView(view: InputComponent<T>): void {
    this.view = view;
  }

  selectAllText(e: Event): void {
    selectAllText(e);
  }

  onDropdownChange({ value }: DropdownChangeEvent, data: Observable<MenuItem[]>): void {
    data.subscribe((data) => {
      const entity = data.find((val) => val?.id === value)

      if (entity)
        this.view.onElementChange(entity);
    });

    this.view.dropdownChange.emit(value);
  }

  onCalendarChange(value: Date): void {
    this.view.calendarChange.emit(value);
  }

  onSwitchChange({ checked }: InputSwitchChangeEvent, data: T): void {
    if (!data) return;

    this.view.switchChange.emit({ checked, data });
  }

  onElementChange(value: T|MenuItem): void {
    this.view.elementChange.emit(value);
  }

  onInputChange({ value }: InputNumberInputEvent): void {
    this.view.inputChange.emit(value);
  }
}
